import { render, staticRenderFns } from "./ChartjsHorizontalBarChartWorker.vue?vue&type=template&id=72b93764&"
import script from "./ChartjsHorizontalBarChartWorker.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartWorker.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartWorker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports